import TripCreateStep from '@/_constants/TripCreateStep.ts';
import type { TripData } from '$/models/Trip.model.ts';

const shouldPrepareDestination = (step: string, context: Pick<TripData, 'trip_destination_place_id'>): boolean =>
  step === TripCreateStep.DESTINATION && !!context.trip_destination_place_id;

export default shouldPrepareDestination;
